import { useQuery } from "@tanstack/react-query";
import { getMetadataTagsList } from "../../metadataTags/api/getMetadataTagsList";

export const useMetadataTagsListQuery = (gameId: string) => {
  return useQuery({
    queryKey: ["metadata-tags"],
    queryFn: async () => {
      return await getMetadataTagsList();
    },
    enabled: !!gameId,
  });
};
